export const PAGE_PATH = '/programa-perda-peso'
export const PAGE_PATH_LEGACY = '/programa-perda-de-peso'

export const PROGRAM_TRAIL_PATH = PAGE_PATH

// UTMs do clique em "Perda de peso" na home: marcam a origem do lead (seguem para a sessão da triagem e o ActiveCampaign).
const PROGRAM_HOME_UTMS = {
  utm_medium: 'organic',
  utm_source: 'lp-cannect',
  utm_campaign: 'lp-perda-de-peso_linhas-de-cuidado_MQL',
  utm_content: 'bt-home-cannect'
}

// Troca os UTMs da busca atual pelos da home e mantém os demais parâmetros.
export const programHomeSearch = (currentSearch = '') => {
  const params = new URLSearchParams(currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch)
  Array.from(params.keys())
    .filter((key) => key.startsWith('utm_'))
    .forEach((key) => params.delete(key))
  const utms = new URLSearchParams(PROGRAM_HOME_UTMS)
  return `?${[utms.toString(), params.toString()].filter(Boolean).join('&')}`
}
export const PROGRAM_TRAIL_LEGACY_PATH = '/programa-perda-peso/triagem'
export const PROGRAM_HERO_SLUG = 'programa_perda_peso'

// Prescritor da consulta inclusa do programa (id em cn_prescribers), configurado por ambiente.
export const PROGRAM_PRESCRIBER_ID = Number(import.meta.env.VITE_WEIGHT_LOSS_PROGRAM_PRESCRIBER_ID || 0)

export const HEADER_NAV = [
  { href: '#incluido', label: 'O que está incluído' },
  { href: '#valores', label: 'Valores' },
  { href: '#como-funciona', label: 'Como funciona' },
  { href: '#duvidas', label: 'Dúvidas' }
] as const

export const PROGRAM_PRICE = 2697
export const PROGRAM_MONTHS = 3
export const PROGRAM_INSTALLMENTS = 3
export const PROGRAM_PIX_DISCOUNT_PERCENT = 5
export const PROGRAM_INSTALLMENT_VALUE = PROGRAM_PRICE / PROGRAM_INSTALLMENTS
export const PROGRAM_PIX_PRICE = Number((PROGRAM_PRICE * (1 - PROGRAM_PIX_DISCOUNT_PERCENT / 100)).toFixed(2))

type TProgramOrderLike = { is_program_order?: boolean }

// O produto do programa é identificado pela API (WEIGHT_LOSS_PROGRAM_PRODUCT_ID lá): o pedido chega com `is_program_order`.
export const isProgramOrder = (order?: TProgramOrderLike | null) => Boolean(order?.is_program_order)

export const TIRZEPATIDA_NAME = 'Tirzepatida Genlab'
export const TIRZEPATIDA_URL = 'https://www.cannect.life/detalhes-produtos/genlab/tirzepatida-20mg-ml-60mg-3ml/33311'

export const PROGRAM_INCLUDED_ITEMS = [
  {
    title: 'Consulta médica por teleatendimento',
    detail: 'Seu médico segue com você durante os 3 meses'
  },
  {
    title: `${TIRZEPATIDA_NAME}, quando indicada`,
    detail: 'Conforme prescrição do seu médico'
  },
  {
    title: '2 consultas com nutricionista',
    detail: 'Para ajustar sua alimentação'
  },
  {
    title: '1 consulta com psicólogo',
    detail: 'Para cuidar também da parte emocional'
  },
  {
    title: 'Enfermagem contínua',
    detail: 'Apoio para tirar dúvidas e acompanhar sua rotina'
  }
] as const
export const WEIGHT_LOSS_PERCENT = 20
// Perda média ilustrada na tela de IMC (exemplo do design: 80 kg → ~72 kg). Pendente de validação clínica.
export const PROGRAM_ESTIMATED_LOSS_PERCENT = 10

export const MARQUEE_ITEMS = [
  'Avaliação médica inicial',
  '2 consultas com nutricionista',
  'Avaliação psicológica',
  'Acompanhamento do time de enfermagem',
  'Monitoramento da evolução',
  'Cuidado multidisciplinar'
]

export const ROTATOR_WORDS = ['a sua alimentação', 'as suas emoções', 'a sua rotina', 'a sua saúde']

export const TEAM_TABS = [
  {
    id: 'medico',
    label: 'Médico',
    description: 'Avalia sua saúde de forma individualizada e define o seu plano de cuidado.',
    items: [
      'Avaliação médica inicial',
      'Consulta médica de acompanhamento',
      'Medicação durante o período do programa, quando houver indicação clínica e prescrição médica, conforme condições do programa'
    ]
  },
  {
    id: 'nutricionista',
    label: 'Nutricionista',
    description: 'Orientação alimentar adaptada à sua rotina e às suas preferências.',
    items: ['2 consultas com nutricionista']
  },
  {
    id: 'psicologo',
    label: 'Psicólogo',
    description: 'Atenção à relação com a comida, às emoções e ao bem-estar.',
    items: ['Avaliação psicológica']
  },
  {
    id: 'enfermagem',
    label: 'Enfermagem',
    description: 'Acompanhamento contínuo do time de enfermagem',
    items: ['Acompanhamento do time de enfermagem', 'Monitoramento da evolução ao longo do programa']
  }
] as const

export const formatBrl = (value: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value)

export const PRICING_ROWS = [
  { id: 'consulta', label: 'Consulta médica', separatePrice: 420 },
  { id: 'tratamento', label: 'Tratamento para 3 meses*', separatePrice: 2300 },
  { id: 'psicologa', label: 'Consulta com psicóloga', separatePrice: 200 },
  { id: 'nutri', label: '2 consultas com nutricionista', separatePrice: 300 },
  { id: 'enfermagem', label: 'Acompanhamento de enfermagem', separatePrice: 450 }
] as const

export const PRICING_SEPARATE_TOTAL = PRICING_ROWS.reduce((sum, row) => sum + row.separatePrice, 0)

export const JOURNEY_STEPS = [
  {
    n: '1',
    badge: 'Comece aqui',
    title: 'Triagem online',
    text: 'Você responde algumas perguntas e descobre se o programa pode fazer sentido para você.'
  },
  {
    n: '2',
    title: 'Avaliação médica',
    text: 'O médico avalia seu caso de forma individualizada e define o plano de cuidado.'
  },
  {
    n: '3',
    title: 'Cuidado multidisciplinar',
    text: 'Consultas com nutricionista, avaliação psicológica e apoio da enfermagem.'
  },
  {
    n: '4',
    title: 'Acompanhamento',
    text: 'Monitoramento da sua evolução e consulta médica de acompanhamento.'
  }
] as const

export const COMPARE_ALONE = [
  'Sem orientação profissional',
  'Foco só no número da balança',
  'Ninguém acompanhando a sua evolução',
  'Dúvidas sem ter a quem recorrer'
]

export const COMPARE_PROGRAM = [
  'Avaliação médica individualizada',
  'Nutrição, psicologia e enfermagem juntas',
  'Monitoramento da evolução ao longo do programa',
  'Time de enfermagem ao seu lado'
]

export const FAQ_GROUPS = [
  {
    title: 'Sobre o programa',
    items: [
      {
        question: 'Quanto tempo dura o programa?',
        answer:
          'O programa inicial tem duração de 3 meses, com acompanhamento profissional durante esse período. Ao final, sua evolução poderá ser reavaliada para definir os próximos passos do tratamento.'
      },
      {
        question: 'O programa é totalmente online?',
        answer:
          'As consultas e os acompanhamentos são realizados de forma online, oferecendo praticidade para que você cuide da sua saúde de onde estiver. Caso seja necessário algum exame ou atendimento presencial, o profissional responsável poderá orientar você.'
      },
      {
        question: 'Como são realizadas as consultas?',
        answer:
          'As consultas são realizadas por teleatendimento, permitindo que você converse com os profissionais de saúde sem precisar se deslocar. Durante o atendimento, o profissional avalia suas necessidades e orienta os próximos passos do tratamento.'
      },
      {
        question: 'Vou receber algum suporte durante o tratamento?',
        answer:
          'Sim! Você contará com o acompanhamento de uma equipe multidisciplinar, formada por médicos, nutricionistas, psicólogos e profissionais de enfermagem. Nosso objetivo é apoiar você durante sua jornada, oferecendo orientações e acompanhamento para uma perda de peso mais segura.'
      }
    ]
  },
  {
    title: 'A equipe multidisciplinar',
    items: [
      {
        question: 'Como funciona o acompanhamento nutricional?',
        answer:
          'Você terá duas consultas com nutricionista durante o programa inicial. O objetivo é compreender seus hábitos alimentares, orientar ajustes na alimentação e apoiar mudanças que favoreçam sua saúde e seus resultados.'
      },
      {
        question: 'Por que o programa inclui avaliação psicológica?',
        answer:
          'O emagrecimento também envolve emoções, comportamentos e hábitos. A avaliação psicológica ajuda a compreender fatores que podem influenciar sua relação com a alimentação e apoiar uma jornada de cuidado mais completa.'
      },
      {
        question: 'Qual é o papel da equipe de enfermagem?',
        answer:
          'A equipe de enfermagem oferece suporte durante a jornada, ajudando com orientações relacionadas ao tratamento, acompanhamento da evolução e identificação de situações que precisam ser encaminhadas para avaliação médica.'
      }
    ]
  },
  {
    title: 'Contratação e pagamento',
    items: [
      {
        question: 'A medicação está inclusa no valor do plano?',
        answer:
          'O programa reúne acompanhamento médico, nutricional, psicológico e de enfermagem. A inclusão da medicação depende das condições do plano contratado, que serão apresentadas antes da confirmação da compra.'
      },
      {
        question: 'Como faço para agendar minha primeira consulta?',
        answer:
          'Após preencher a avaliação inicial e seguir com a contratação, você receberá orientações sobre o agendamento da primeira consulta e as próximas etapas da sua jornada.'
      },
      {
        question: 'Vou receber a medicação após o pagamento?',
        answer:
          'Após a confirmação do pagamento, você seguirá para a avaliação médica. Caso o medicamento seja indicado e prescrito, o pedido será processado e enviado conforme as condições do plano e os prazos de entrega informados.'
      },
      {
        question: 'Posso cancelar o programa a qualquer momento?',
        answer:
          'Você pode solicitar o cancelamento quando desejar, conforme as condições de contratação. Eventuais valores referentes a serviços já realizados ou medicamentos já fornecidos seguirão as regras previstas no contrato.'
      }
    ]
  },
  {
    title: 'Medicação',
    items: [
      {
        question: 'Posso escolher qual medicamento quero utilizar?',
        answer:
          'Você pode conversar com o médico sobre suas preferências e expectativas, mas a definição do medicamento e da dosagem será feita pelo profissional, considerando critérios clínicos e de segurança.'
      },
      {
        question: 'Os medicamentos são seguros?',
        answer:
          'Medicamentos para emagrecimento podem ser utilizados com segurança quando são adequadamente indicados, prescritos e acompanhados. Como qualquer tratamento medicamentoso, existem contraindicações, riscos e possíveis efeitos adversos. Por isso, a avaliação médica é indispensável.'
      },
      {
        question: 'Como recebo o medicamento prescrito?',
        answer:
          'Quando houver prescrição e fornecimento de medicamento pelo programa, você receberá as orientações sobre disponibilidade, pagamento, entrega e cuidados necessários para o armazenamento e a utilização.'
      },
      {
        question: 'E se eu tiver efeitos colaterais ou não me adaptar ao medicamento?',
        answer:
          'Caso apresente sintomas ou dificuldades durante o tratamento, informe a equipe de saúde. O profissional responsável poderá avaliar a necessidade de ajustar, interromper ou modificar a conduta. Em caso de sintomas graves, procure atendimento médico imediatamente.'
      }
    ]
  },
  {
    title: 'Durante e depois do tratamento',
    items: [
      {
        question: 'O que faço se tiver dúvidas durante o tratamento?',
        answer:
          'Você contará com os canais de suporte disponibilizados pelo programa para esclarecer dúvidas e receber orientações durante sua jornada. Questões clínicas serão direcionadas aos profissionais de saúde responsáveis.'
      },
      {
        question: 'Em quanto tempo verei resultados?',
        answer:
          'Cada organismo responde de uma maneira, mas algumas pessoas começam a perceber mudanças nas primeiras semanas. Os resultados dependem de fatores como metabolismo, hábitos alimentares e tratamento indicado. Nosso foco é ajudar você a alcançar resultados progressivos e sustentáveis, respeitando seu ritmo.'
      },
      {
        question: 'O que acontece depois dos primeiros 3 meses?',
        answer:
          'Ao final do programa inicial, você poderá avaliar sua evolução com a equipe de saúde. Dependendo dos seus objetivos e da orientação médica, poderá ser proposta a continuidade do acompanhamento.'
      }
    ]
  },
  {
    title: 'Sobre a Genlab e a medicação',
    items: [
      {
        question: 'O que é a Genlab e qual é o seu papel no tratamento?',
        answer:
          'A Genlab é a farmácia de manipulação responsável pela preparação do medicamento, conforme prescrição médica individualizada. A Cannect oferece a jornada de cuidado e acompanhamento prevista no programa.'
      },
      {
        question: 'A tirzepatida manipulada é permitida pela Anvisa?',
        answer:
          'A manipulação de tirzepatida pode ser realizada no Brasil, desde que sejam cumpridas as exigências sanitárias estabelecidas pela Anvisa, incluindo as condições aplicáveis à manipulação e à prescrição individualizada. Isso não significa que a formulação manipulada tenha registro próprio na Anvisa.'
      },
      {
        question: 'Qual é a diferença entre a tirzepatida manipulada e o Mounjaro?',
        answer:
          'Ambos contêm o princípio ativo tirzepatida. Entretanto, o Mounjaro é um medicamento industrializado registrado na Anvisa, enquanto a tirzepatida manipulada é preparada individualmente em farmácia de manipulação. As duas apresentações não são automaticamente equivalentes.'
      },
      {
        question: 'A tirzepatida manipulada pela Genlab é segura e eficaz?',
        answer:
          'A tirzepatida possui estudos científicos que demonstram sua eficácia na redução de peso. Porém, esses resultados foram obtidos com formulações estudadas clinicamente e não comprovam automaticamente a eficácia e a segurança da preparação manipulada pela Genlab. A qualidade da preparação e o acompanhamento médico são fundamentais.'
      },
      {
        question: 'Preciso de receita médica para receber o medicamento?',
        answer:
          'Sim. A tirzepatida é um medicamento sujeito a prescrição médica. Durante a consulta, o profissional avaliará seu histórico de saúde e definirá se o tratamento é indicado, assim como a dose apropriada.'
      },
      {
        question: 'Como vou receber a medicação e quais cuidados devo ter?',
        answer:
          'Após a avaliação médica e o cumprimento das etapas necessárias para o fornecimento, a farmácia responsável realizará a preparação conforme a receita. As orientações de entrega, conservação e aplicação devem ser seguidas rigorosamente para preservar a qualidade do medicamento.'
      }
    ]
  }
]

export const FAQ_ITEMS = FAQ_GROUPS.flatMap((group) => group.items)

export const SEO_TITLE = 'Programa de perda de peso com acompanhamento médico'
export const SEO_DESCRIPTION =
  'Programa Cannect de perda de peso com médico, nutricionista, psicólogo e enfermagem. Online, R$ 2.697,00 em até 3x ou 5% de desconto no PIX, em um plano de 3 meses.'
export const SEO_KEYWORDS =
  'programa perda de peso, emagrecimento com acompanhamento médico, nutricionista, psicólogo, enfermagem, Cannect, tratamento para emagrecer'
